import { ACTION_PREFIX } from './actionPrefix.const';

export const DESTROY_STORE_ACTION = `${ACTION_PREFIX.BASE}/destroyStore`;
